import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getPostById = async(id: string) => {
  const url = `${generateEndpoint('getPostById')}?id=${id}`
  return fetchGet(url, null)
}